import Registrations from './Registrations';

export default Registrations;
